import { EventEmitter } from 'eventemitter3';

export type KeyOf<T> = Extract<keyof T, string>;
type EventHandlerMap<EventDataMap extends {}> = {
  [Event in KeyOf<EventDataMap>]?: (
    data: EventDataMap[Event],
    lastData?: EventDataMap[Event]
  ) => any;
};

export default class Bus<EventDataMap extends {}> {
  private readonly emitter = new EventEmitter();

  public emit(dataSet: Partial<EventDataMap>): void {
    for (const [event, data] of Object.entries(dataSet)) {
      this.emitter.emit(event, data);
    }
  }

  public on(handlers: EventHandlerMap<EventDataMap>): this {
    for (const [event, handler] of Object.entries(handlers)) {
      this.emitter.on(event, handler as any);
    }
    return this;
  }

  public once(handlers: EventHandlerMap<EventDataMap>): this {
    for (const [event, handler] of Object.entries(handlers)) {
      this.emitter.once(event, handler as any);
    }
    return this;
  }

  public off(handlers: EventHandlerMap<EventDataMap>): this {
    for (const [event, handler] of Object.entries(handlers)) {
      this.emitter.off(event, handler as any);
    }
    return this;
  }

  // 用来绑定 class components
  public bindComponent(
    component: React.Component<any, any>,
    handlers: Partial<EventHandlerMap<EventDataMap>>
  ) {
    const didMount = component.componentDidMount;
    const willUnmount = component.componentWillUnmount;

    component.componentDidMount = () => {
      this.on(handlers);
      if (didMount) {
        return didMount.apply(component);
      }
    };

    component.componentWillUnmount = () => {
      this.off(handlers);
      if (willUnmount) {
        return willUnmount.apply(component);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/services/lib/bus.ts